import { S3Client, URLObject } from '@kalos/kalos-rpc';
import {
  KALOS_BRAND_BUCKET,
  KALOS_LOGO_KEY,
  type KalosLogoVariant,
  kalosLogoQueryKey,
} from '@kalos/ui';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const kalosLogoQueryOptions = (grpcBaseUrl: string, variant: KalosLogoVariant = 'default') =>
  queryOptions({
    queryKey: kalosLogoQueryKey(variant),
    queryFn: async () => {
      const res = await new S3Client(grpcBaseUrl).GetDownloadURL(
        URLObject.create({ bucket: KALOS_BRAND_BUCKET, key: KALOS_LOGO_KEY[variant] }),
      );
      if (!res?.url) throw new Error(`Kalos logo (${variant}) is unavailable`);
      return res.url;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });

export const useKalosLogoQuery = (grpcBaseUrl: string, variant: KalosLogoVariant = 'default') =>
  useQuery(kalosLogoQueryOptions(grpcBaseUrl, variant));
